import { ConectoresFonteDadoCadastro } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/configuracao/:idConfiguracao/fonte/dado/:id',
    text: 'Fonte de Dado',
    component: ConectoresFonteDadoCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
